import React, { useEffect, useState } from 'react';
import ProviderCommonApi from '../../../../API/provider/common-api';
import MarketOzonApi from '../../../../API/market/ozon-api';
import SelectInput from '../../../../components/Basic/Inputs/SelectWithInput';

export default function OzonCategorySelect({
  category = '',
  onChange = () => { },
  isAllCategotries = true,
  style,
  label = '',
  searchParams = {},
  ...props
}) {
  const [list, setList] = useState([]);
  const [value, setValue] = useState('');
  const [isOk, setIsOk] = useState(null);

  const findCategory = (search) => {
    (isAllCategotries
      ? MarketOzonApi.getCategories({ data: { search } })
      :
      ProviderCommonApi.getOzonCategories1({ data: { categoryOzonSearch: search, ...searchParams } })
    ).then((r) => {
      const categories = r.categories;
      setList(categories);
      if (r.matchedCategory) {
        setIsOk(true);
      } else {
        setIsOk(false);
      }
    });
  };

  const onSelect = (v) => {
    // setValue(v);
    onChange(v);
    setIsOk(null);
  };

  const onBlur = () => {
    if (isOk) {
      onSelect(value);
      //setIsOk(null);
    }
  };

  const deleteCategory = () => {
    onChange('');
    setIsOk(null);
  };

  useEffect(() => {
    setValue(category);
  }, [category]);

  const onChangeInput = (v) => {
    if (v.length === 0) {
      //onChange('');
    }
    setValue(v);
    findCategory(v || '');
  };

  return (
    <SelectInput
      label={label}
      select={value}
      list={list}
      add={false}
      width={'300px'}
      preventState={true}
      addText={'Добавить'}
      defaultText={'Без категории'}
      placeholder={'Категория озон'}
      {...props}
      isOk={isOk}
      onBlur={onBlur}
      onChange={onChangeInput}
      onSelect={onSelect}
      deletePlace={deleteCategory}
      onFocus={(v) => findCategory(v || '')}
    />
  );
}
